import classnames from 'classnames';
import useClickOutside from 'hooks/useClickOutside';
import React, { useEffect, useRef } from 'react';

import BackDrop from './BackDrop';

const CSS = require('./Popover.module.scss');

interface PopoverProps {
  show: boolean;
  name: string;
  children: any;
  underNavbar?: boolean;
  className?: string;
  noBackdrop?: boolean;
  onClose: (e?: any) => void;
  onOutSideClick?: (e?: any) => void;
}

function Popover({
  show,
  name,
  children,
  underNavbar = false,
  className,
  noBackdrop = false,
  onClose,
  onOutSideClick,
}: PopoverProps) {
  const ref = useRef(null);
  useClickOutside(ref, onOutSideClick ? onOutSideClick : onClose);

  useEffect(() => {
    const onKeyUp = (e) => {
      if (show && e.key === 'Escape') {
        e?.preventDefault();
        e?.stopPropagation();
        onClose(e);
      }
    };

    window.addEventListener('keyup', onKeyUp);

    return () => window.removeEventListener('keyup', onKeyUp);
  }, [show, onClose]);

  if (!show) {
    return null;
  }

  return (
    <div data-test-id={name}>
      {show && (
        <div
          ref={ref}
          className={classnames(CSS.Popover, { [className]: className })}
        >
          {children}
        </div>
      )}
      {!noBackdrop && <BackDrop backdropId={name} underNavbar={underNavbar} />}
    </div>
  );
}

export default Popover;
